/*
  Z-index values that we set in JS/TS rather than CSS. This need to be kept in sync (manually, unfortunately)
  with src/assets/styles/variables/z_indices.scss

  Best of all would be not to use these at all, of course.
 */

export const Z_INDEX_MAP_MODAL = 500;
export const Z_INDEX_MAP_GATE_STORYLET_MODAL = 502;
export const Z_INDEX_MAP_ADMIN_OVERLAY = 10000;
